// theme.ts
import { colors, getColor } from './colors';
import { fonts, getFontStyle } from './fonts';
// 테마 객체 생성
export const theme = {
    colors,
    fonts,
    getColor,
    getFontStyle,
};
//# sourceMappingURL=theme.js.map